import { render, staticRenderFns } from "./NavigationMobileGroup.vue?vue&type=template&id=6f7d7c4a&scoped=true"
import script from "./NavigationMobileGroup.vue?vue&type=script&lang=js"
export * from "./NavigationMobileGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f7d7c4a",
  null
  
)

export default component.exports